export default {
  /* Cinza */
  "gray-ebony": "#323238",
  "gray-shuttle": "#626567",
  "gray-chateau": "#A5A5A5",
  zircon: "#e1e1e6",

  /* Azul */
  "blue-maya-blue": "#6fbafd",
  "picton-blue": "#60a6dd",

  /* Verde */

  "green-dull-lime": "#34cd4f",
  "light-green": "#87e49e",
  "green-madang": "#c2f6b7",
  "green-snowy-mint": "#d1f8c9",
  "green-peppermint": "#e0fadb",
  "green-feta": "#effced",

  /* Vermelho e Rosa */

  "red-ruby": "#ed145b",
  "red-brick": "#d93b54",
  "red-roman": "#e85f5c",
  "red-geraldine": "#ec7c79",
  "pink-sea-pink": "#f09997",
  "pink-beauty-bush": "#f4b6b4",
  "pink-cosmos": "#f8d3d2",

  /* Laranja */

  "orange-chocolate": "#d55b1d",
  "orange-chilean-fire": "#d15d2b",
  "orange-tree-popy": "#fd951f",

  /* Amarelo */

  "yellow-fire-bush": "#e59b2c",
  "yellow-moon": "#edbc20",

  /* Lilás */

  "lavender-indigo": "#a259ff",
}
